/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiClientsIdQueryResponse,
  GetApiClientsIdPathParams,
} from '../models/GetApiClientsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiClientsIdQueryResponseSchema } from '../zod/getApiClientsIdSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiClientsIdQueryKey = (id: GetApiClientsIdPathParams['id']) =>
  [{ url: '/api/clients/:id', params: { id: id } }] as const;

export type GetApiClientsIdQueryKey = ReturnType<
  typeof getApiClientsIdQueryKey
>;

/**
 * {@link /api/clients/:id}
 */
export async function getApiClientsId(
  id: GetApiClientsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiClientsIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/clients/${id}`, ...requestConfig });
  return getApiClientsIdQueryResponseSchema.parse(res.data);
}

export function getApiClientsIdQueryOptions(
  id: GetApiClientsIdPathParams['id'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiClientsIdQueryKey(id);
  return queryOptions<
    GetApiClientsIdQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiClientsIdQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiClientsId(id, config);
    },
  });
}

/**
 * {@link /api/clients/:id}
 */
export function useGetApiClientsId<
  TData = GetApiClientsIdQueryResponse,
  TQueryData = GetApiClientsIdQueryResponse,
  TQueryKey extends QueryKey = GetApiClientsIdQueryKey,
>(
  id: GetApiClientsIdPathParams['id'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiClientsIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiClientsIdQueryKey(id);

  const query = useQuery(
    {
      ...getApiClientsIdQueryOptions(id, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
